import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { CrewChangeRequestComponent } from 'src/app/front-user/services/CrewChange/crew-change-request/crew-change-request.component';
import { User } from 'src/app/front-user/shared/models/user.model';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { CrewChangeAdminDTO } from 'src/app/shared/models/crewChange.model';
import { CCApprovalDecision, FormMode, Languages, ServiceStatus } from 'src/app/shared/models/enums.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { CrewChangeService } from 'src/app/shared/services/crewChange.service';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { CrewchangeReviewerDecisionComponent } from '../crewchange-reviewer-decision/crewchange-reviewer-decision.component';

@Component({
  selector: 'app-crewchange-approval-decision',
  templateUrl: './crewchange-approval-decision.component.html',
  styleUrls: ['./crewchange-approval-decision.component.css']
})
export class CrewchangeApprovalDecisionComponent implements OnInit {

  submitted = false;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest//= new BaseRequest();
  approvalDecision = CCApprovalDecision;
  approvalDecisionKeys = Object.keys(this.approvalDecision);
  displayedLang: string;
  decisionValue: number;
  crewChangeApprovalForm: FormGroup;
  currentUser: User = new User();
  adminDecisionObject: CrewChangeAdminDTO = new CrewChangeAdminDTO();
  showRequest = false;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  isLoaded: boolean = false;
  isErrorMessage: boolean = false;
  @ViewChild('CrewChangeReviewerDecision',{static: false}) CrewChangeReviewerDecision: CrewchangeReviewerDecisionComponent;
  @Input() public isShow: boolean = true;
  // @Input() IsAdminMode: boolean = false;
  // @Input() public RequestStatus: number;
  responseObj: ResponseObject = new ResponseObject();
  lockTaskErrorMessage: boolean = false;
  numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  isNotesRequired: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private crewChangeService: CrewChangeService,
  ) {
    this.approvalDecisionKeys = this.approvalDecisionKeys.slice(this.approvalDecisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    } else {
      window.history.back();
    }
    this.currentUser = this.globalSrv.user;
  }

  ngOnInit() {
    this.buildForm(null);
  }

  buildForm(decision) {
    this.crewChangeApprovalForm = this.formBuilder.group({
      ApprovalDecision: ['', [Validators.required]],
      Notes: [''],
    });
    if (decision == CCApprovalDecision.CCApproval_Approve) {
      this.crewChangeApprovalForm = this.formBuilder.group({
        ApprovalDecision: ['', [Validators.required]],
        Notes: [''],
        ApprovalTotalFees:['', [Validators.required, Validators.pattern(this.numberRegex)]]
      });
    }
}

get f() {
  return this.crewChangeApprovalForm.controls;
}

getBaseRequest() {
  this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
    d => {
      this.baseRequestDTO = d.Data;
      this.requestStatus = this.baseRequestDTO.StatusId;
      // this.agentId = this.baseRequestDTO.RequestorId;
      this.isLoaded = true;
      if ((history.state.data && history.state.data.isCompleted) || this.requestStatus == ServiceStatus.CrewChange_PendingAgentApproval) {
        this.getCrewChangeRequest();
        this.formMode = FormMode.Readonly;
        this.crewChangeApprovalForm.disable();
      }
    }
  )
}

getCrewChangeRequest() {
  this.crewChangeService.getById(this.baseRequestId).pipe(first()).subscribe(
    (resObj: ResponseObject) => {
      this.responseObj = resObj;
      if (this.responseObj.Success) {
        if (this.responseObj.Data["ApprovalDecision"] == CCApprovalDecision.CCApproval_Approve) {
            this.decisionValue = CCApprovalDecision.CCApproval_Approve;
            this.buildForm(CCApprovalDecision.CCApproval_Approve);
            this.crewChangeApprovalForm.patchValue({
            ApprovalDecision: this.responseObj.Data["ApprovalDecision"],
            Notes: this.responseObj.Data['ApprovalNotes'],
            ApprovalTotalFees: this.responseObj.Data['ApprovalTotalFees']
          });
        } else {
          this.buildForm(null);
          this.crewChangeApprovalForm.patchValue({
          ApprovalDecision: this.responseObj.Data["ApprovalDecision"],
          Notes: this.responseObj.Data['ApprovalNotes'],
        });
        }

      }
    }

  );
}

  changeDecision(value) {
    this.buildForm(value);
    this.crewChangeApprovalForm.patchValue({
      ApprovalDecision: value
    });
    this.decisionValue = value;
    if (value == this.approvalDecision.CCApproval_MoreInformation || value == this.approvalDecision.CCApproval_Reject) {
      this.isNotesRequired = true;
    } else {
      this.isNotesRequired = false;
    }
  }

  onSubmit(b) {
    this.submitted = true;
    // stop here if form is invalid
    if (this.crewChangeApprovalForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.adminDecisionObject.ApprovalDecision = this.crewChangeApprovalForm.controls['ApprovalDecision'].value;
    this.adminDecisionObject.ApprovalNotes = this.crewChangeApprovalForm.controls['Notes'].value;
    if (this.adminDecisionObject.ApprovalDecision == CCApprovalDecision.CCApproval_Approve) {
      this.adminDecisionObject.ApprovalTotalFees = this.crewChangeApprovalForm.controls['ApprovalTotalFees'].value;
    }
  this.adminDecisionObject.AdminEmail = this.currentUser.UserName;
  this.adminDecisionObject.Id = this.baseRequestId;

  this.crewChangeService.AddApprovalDecision(this.adminDecisionObject)
    .subscribe(
      (data: ResponseObject) => {
        if (data.Success) {
          this.globalSrv.isLoaderEnabled = false;
          this.crewChangeApprovalForm.reset();
          this.loading = false;
          this.showRequest = true;
          this.isErrorMessage = false;
        }
        else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
          this.lockTaskErrorMessage = true;
          this.showRequest = true;
          this.globalSrv.isLoaderEnabled = false;
        }
        else {
          this.globalSrv.isLoaderEnabled = false;
          this.showRequest = true;
          this.isErrorMessage = true;
          this.loading = false;
        }

      });
}

}
